import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';


export interface Breadcrumb {
  label: string;
  url: string;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs = this.breadcrumbs$.asObservable();

  private readonly DASHBOARD: Breadcrumb = {
    label: 'قائمة البرامج/',
    url: '/pages/dashboard'
  };

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const isDashboard = this.router.url === '/pages/dashboard';

      if (isDashboard) {
        this.breadcrumbs$.next([this.DASHBOARD]);
        return;
      }
      const dynamicLabel = history.state?.['breadcrumb']
        ?? sessionStorage.getItem('serviceName'); // fallback

      if (dynamicLabel) {
        this.breadcrumbs$.next([
          this.DASHBOARD,
          { label: dynamicLabel, url: this.router.url }
        ]);
      } else {

        const crumbs = this.buildBreadcrumbs(this.route.root);
        this.breadcrumbs$.next([this.DASHBOARD, ...crumbs]);
      }
    });
  }

  private buildBreadcrumbs(
    route: ActivatedRoute,
    url = '',
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    for (const child of route.children) {
      const routeURL = child.snapshot.url.map(s => s.path).join('/');
      const fullUrl = routeURL ? `${url}/${routeURL}` : url;
      const label = child.snapshot.data['breadcrumb'];

      if (label) {
        breadcrumbs.push({ label, url: fullUrl });
      }

      return this.buildBreadcrumbs(child, fullUrl, breadcrumbs);
    }
    return breadcrumbs;
  }
}
